import Icon from 'components/Icon';
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import { AuthContext } from 'constants/contexts';
import { env } from 'constants';

function ProfileButton() {
  const { pathname } = useLocation();
  const { isLoggedIn } = useContext(AuthContext);

  // todo better path match
  const isActive = pathname === '/profile';

  if (env.IS_MARKETPLACE) {
    return null;
  }

  return (
    <Stack
      alignItems="center"
      component={Link}
      to={isLoggedIn ? '/profile' : '/login'}
      className="footer-btn"
      spacing="6px"
    >
      {
        isActive ? <Icon name="user-filled" size={24} sx={{ color: 'primary.main' }} /> : <Icon name="user-outlined" size={24} sx={{ color: 'text.secondary' }} />
      }
      <Typography variant="body-caption" color={isActive ? 'primary' : 'text.secondary'}>
        Profile
      </Typography>
    </Stack>
  );
}

export default ProfileButton;
